import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles } from 'lucide-react';
import { Event } from '../types/events';

interface BookingSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  event: Event;
}

export const BookingSuccessDialog: React.FC<BookingSuccessDialogProps> = ({
  isOpen,
  onClose,
  event
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="w-full max-w-full sm:max-w-md p-4 sm:p-6 rounded-none sm:rounded-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg sm:text-xl">
            <Sparkles className="h-5 w-5 text-primary" />
            Booking Confirmed!
          </DialogTitle>
          <DialogDescription className="text-base sm:text-sm">
            Your booking has been confirmed successfully. You will receive a confirmation email shortly.
          </DialogDescription>
        </DialogHeader>
        <div className="text-center py-6">
          <div className="mb-4">
            <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
              <Sparkles className="h-8 w-8 text-primary" />
            </div>
          </div>
          <p className="text-lg sm:text-base font-medium text-gray-900 mb-2">
            Thank you for your booking!
          </p>
          <p className="text-base sm:text-sm text-gray-500">
            You can view your booking details in the My Bookings section.
          </p>
        </div>
        <div className="mt-4 flex justify-center">
          <Button onClick={onClose} className="w-full sm:w-auto py-3 sm:py-2 text-base sm:text-sm">
            View My Bookings
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingSuccessDialog; 